<template>
  <v-container
    class="align-start"
    :class="[
      leftSideBar ? 'myrep moveUp' : '',
      $vuetify.display.xs ? 'minHeightMobile' : 'minHeightDesktop',
    ]"
    role="presentation"
    max-width="1024px"
  >
    <template v-if="repPage">
      <!-- Header = My Representative -->
      <v-row justify="start" class="main-body ml-0 mr-0" align-content="center">
        <v-col cols="auto">
          <v-img src="./assets/group.svg" height="30px" width="auto" role="presentation" alt="" />
        </v-col>
        <v-col cols="auto">
          <h1 class="text-h1 font-weight-regular text-white" role="heading" aria-level="1">
            {{ $t(reps && reps.length > 1 ? 'L_my_rep_title_plural' : 'L_my_rep_title') }}
          </h1>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" v-if="reps && reps.length > 0" class="bottomSpacingToAccountForMenu">
          <v-card v-for="rep in reps" :key="rep.agentId" class="ma-4 py-4">
            <v-card-text>
              <v-row justify="center">
                <!-- <temp>---Agent Photo-----------------------------------------</temp> -->
                <v-col
                  cols="12"
                  sm="3"
                  md="2"
                  :mb-3="$vuetify.display.xs"
                  class="d-flex justify-center"
                >
                  <v-img
                    alt="Rep photo"
                    class="mx-auto rep-image"
                    height="80px"
                    max-width="80px"
                    :src="rep.displayPic || repFallbackImage"
                  >
                    <!-- Content to display if the main src fails to load -->
                    <template v-slot:error>
                      <v-img
                        class="mx-auto"
                        height="80px"
                        max-width="80px"
                        :src="repFallbackImage"
                      ></v-img>
                    </template>
                  </v-img>
                </v-col>
                <!-- <temp>---Agent Info-----------------------------------------</temp> -->
                <v-col cols="12" sm="9" md="10">
                  <v-row justify="center">
                    <!-- Information List -->
                    <v-col cols="7" sm="6" md="4" lg="4" class="noLeftRightPadding">
                      <v-row justify-start>
                        <v-col cols="12" class="noLeftRightPadding">
                          <h3
                            role="heading"
                            aria-level="2"
                            class="heading_three font-weight-medium mb-2"
                            :class="{ 'text-center': $vuetify.display.xs }"
                          >
                            {{ rep.displayName }}
                          </h3>
                          <h5
                            role="presentation"
                            v-if="
                              rep.isRvp &&
                              rep.addresses.filter(
                                (address: any) =>
                                  address.type === 'home' &&
                                  !(
                                    address.state === 'NF' ||
                                    address.state === 'PE' ||
                                    address.state === 'NS' ||
                                    address.state === 'NB' ||
                                    address.state === 'PQ' ||
                                    address.state === 'ON' ||
                                    address.state === 'MB' ||
                                    address.state === 'SK' ||
                                    address.state === 'AB' ||
                                    address.state === 'BC' ||
                                    address.state === 'YT' ||
                                    address.state === 'NT' ||
                                    address.state === 'NU'
                                  )
                              ).length > 0
                            "
                            class="heading_five font-weight-medium mb-1 pb-1"
                            :class="{ 'text-center': $vuetify.display.xs }"
                          >
                            {{ $t('L_' + rep.title) }}
                          </h5>
                          <h5
                            role="presentation"
                            class="heading_five font-weight-medium mb-1 pb-1"
                            :class="{ 'text-center': $vuetify.display.xs }"
                          >
                            {{
                              $t(
                                rep.products.length > 1
                                  ? 'L_rep_servicing_product_plural'
                                  : 'L_rep_servicing_product'
                              )
                            }}
                          </h5>
                          <div
                            v-for="(item, index) in rep.products"
                            :key="index"
                            class="font-size--14 mb-1"
                            :class="{ 'text-center': $vuetify.display.xs }"
                          >
                            {{ item }}
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>

                    <!-- <temp>---CONTACT------------------------------------------</temp> -->
                    <v-col
                      cols="8"
                      sm="6"
                      md="4"
                      lg="4"
                      class="px-0"
                      :class="$vuetify.display.xs ? '' : 'pl-4'"
                    >
                      <h4
                        :class="$vuetify.display.xs ? 'text-center' : 'text-left'"
                        class="text-h4 font-weight-medium pb-3"
                      >
                        {{ $t('L_contact') }}
                      </h4>
                      <p
                        v-if="rep.office && rep.office.phone"
                        class="text-h5 font-weight-bold pb-3"
                      >
                        <v-icon color="primary" :icon="mdiPhone" />
                        <a :href="'tel:+1' + rep.office.phone" class="ml-2 blueLinkPointer">{{
                          phoneFormat(rep.office.phone)
                        }}</a>
                      </p>
                      <p v-if="rep.useCellPhone && rep.cell" class="text-h5 font-weight-bold pb-3">
                        <v-icon color="primary" :icon="mdiCellphone" />
                        <a :href="'tel:+1' + rep.cell" class="ml-2 blueLinkPointer">{{
                          phoneFormat(rep.cell)
                        }}</a>
                      </p>
                      <p v-if="rep.office && rep.office.fax" class="text-h5 font-weight-bold pb-3">
                        <v-icon color="primary" :icon="mdiPrinter" />
                        <a :href="'tel:+1' + rep.office.fax" class="ml-2 blueLinkPointer">{{
                          phoneFormat(rep.office.fax)
                        }}</a>
                      </p>
                      <p v-if="rep.email" class="text-h5 font-weight-bold pb-3">
                        <v-icon color="primary" :icon="mdiEmail" />
                        <a
                          @click.prevent="emailRep(rep.agentId)"
                          :href="'tel:+1' + rep.office.fax"
                          class="ml-2 blueLinkPointer"
                          >{{ $t('L_rep_email_me') }}</a
                        >
                      </p>
                      <p v-if="rep.appointmentUrl" class="text-h5 font-weight-bold pb-3">
                        <v-icon color="primary" :icon="mdiCalendar" />
                        <a
                          @click.prevent="openCalendar(rep.appointmentUrl)"
                          href=""
                          class="ml-2 blueLinkPointer"
                          >{{ $t('L_make_an_appointment') }}</a
                        >
                      </p>
                    </v-col>

                    <!-- <temp>---REP ADDRESS----------------------</temp> -->
                    <v-col cols="7" sm="12" md="4" lg="4">
                      <MyRepAddressComponent :rep="rep" />
                    </v-col>
                  </v-row>
                  <v-divider class="mt-4 mb-3 hidden-sm-and-down" />
                </v-col>
              </v-row>
              <v-divider class="mt-4 mb-3 hidden-md-and-up" />
              <v-row align-content="start" justify="start">
                <v-col v-if="$vuetify.display.mdAndUp" cols="2" />
                <v-col cols="12" md="4">
                  <h5 class="text-h5 mb-2">{{ $t('L_rep_help_with') }}:</h5>
                  <template v-for="(product, i) in rep.licensedProducts" :key="i">
                    <!-- <v-col> -->
                    <p v-if="filterProducts(product)" class="pb-2">
                      <v-icon color="primary" :icon="mdiCheckCircle" />
                      <span class="ml-2 text-h4">{{ translatedProductName(product) }}</span>
                    </p>
                    <!-- </v-col> -->
                  </template>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </template>

    <!-- <temp>---Modify this section for Left Bar on Wide Desktop | Guidance Calc for Life or Investment Rep Section------------</temp> -->
    <v-row v-else-if="reps && reps.length === 1" :class="{ backgroundBlueGradient: leftSideBar }">
      <v-col cols="12" v-for="rep in reps" :key="rep.agentId">
        <v-row justify="center" class="pa-0 ma-0">
          <v-col
            cols="12"
            class="text-center d-flex align-center flex-column pa-0 ma-0"
            :mb-3="$vuetify.display.xs"
          >
            <div class="mb-4 mt-4">
              <v-img
                alt="Rep photo"
                class="mx-auto"
                height="80px"
                width="80px"
                :src="rep.displayPic || repFallbackImage"
              >
                <!-- Content to display if the main src fails to load -->
                <template v-slot:error>
                  <v-img class="mx-auto" height="80px" width="80px" :src="repFallbackImage"></v-img>
                </template>
              </v-img>
            </div>
            <h3
              role="heading"
              aria-level="2"
              class="heading_three font-weight-bold font-size--20 mb-2"
              :class="leftSideBar ? 'whitetext' : ''"
            >
              {{ rep.displayName }}
            </h3>
            <h5
              role="presentation"
              v-if="
                rep.isRvp &&
                rep.addresses.filter(
                  (address: any) =>
                    address.type === 'home' &&
                    !(
                      address.state === 'NF' ||
                      address.state === 'PE' ||
                      address.state === 'NS' ||
                      address.state === 'NB' ||
                      address.state === 'PQ' ||
                      address.state === 'ON' ||
                      address.state === 'MB' ||
                      address.state === 'SK' ||
                      address.state === 'AB' ||
                      address.state === 'BC' ||
                      address.state === 'YT' ||
                      address.state === 'NT' ||
                      address.state === 'NU'
                    )
                ).length > 0
              "
              class="heading_five font-weight-medium mb-4 font-size--14 mb-1 pb-1"
              :class="{ whitetext: leftSideBar }"
            >
              {{ $t('L_' + rep.title) }}
            </h5>
          </v-col>
          <!-- <temp>---------------------------------------------</temp> -->

          <div justify="center" class="d-flex align-center flex-column pa-0 ma-0">
            <div :class="leftSideBar ? 'justify-left' : 'justify-center'" class="pa-0 ma-0">
              <div
                class="font-size--14 font-weight-bold text-center pa-0 ma-0 mb-2"
                :class="leftSideBar ? 'whitetext' : ''"
              >
                {{ $t('L_contact_me') }}
              </div>
              <div v-if="rep.office && rep.office.phone" class="pt-1 pb-2 text-left">
                <span class="font-size--14 font-weight-medium mr-1"
                  ><v-icon
                    color="primary"
                    class="font-size--24"
                    :class="leftSideBar ? 'whiteicon' : ''"
                    :icon="mdiPhone"
                /></span>
                <a
                  :href="'tel:+1' + rep.office.phone"
                  class="ml-1 text-decoration-none blueLinkPointer"
                  :class="leftSideBar ? 'whitetext' : ''"
                  >{{ phoneFormat(rep.office.phone) }}</a
                >
              </div>
              <div v-if="rep.useCellPhone && rep.cell" class="pt-1 pb-2 text-left">
                <span class="font-size--14 font-weight-medium mr-1"
                  ><v-icon
                    color="primary"
                    class="font-size--24"
                    :class="leftSideBar ? 'whiteicon' : ''"
                    :icon="mdiCellphone"
                /></span>
                <a
                  :href="'tel:+1' + rep.cell"
                  class="ml-1 text-decoration-none blueLinkPointer"
                  :class="leftSideBar ? 'whitetext' : ''"
                  >{{ phoneFormat(rep.cell) }}</a
                >
              </div>
              <div v-if="rep.office && rep.office.fax" class="pt-1 pb-2 text-left">
                <span class="font-size--14 font-weight-medium mr-1"
                  ><v-icon
                    color="primary"
                    class="font-size--24"
                    :class="leftSideBar ? 'whiteicon' : ''"
                    :icon="mdiPrinter"
                /></span>
                <a
                  :href="'tel:+1' + rep.office.fax"
                  class="ml-1 text-decoration-none blueLinkPointer"
                  :class="leftSideBar ? 'whitetext' : ''"
                  >{{ phoneFormat(rep.office.fax) }}</a
                >
              </div>

              <div
                v-if="rep.email"
                class="pt-1 pb-2 text-left d-flex align-start"
                @click.prevent="emailRep(rep.agentId)"
              >
                <span class="font-size--14 font-weight-medium mr-1"
                  ><v-icon
                    color="primary"
                    class="font-size--24"
                    :class="leftSideBar ? 'whiteicon' : ''"
                    :icon="mdiEmail"
                /></span>
                <a
                  :href="'tel:+1' + rep.office.fax"
                  class="ml-1 text-decoration-none blueLinkPointer repLinkWrap"
                  :class="leftSideBar ? 'whitetext' : ''"
                  >{{ $t('L_rep_email_me') }}</a
                >
              </div>

              <div
                v-if="rep.appointmentUrl"
                class="pt-1 pb-2 text-left d-flex align-start"
                @click.prevent="openCalendar(rep.appointmentUrl)"
              >
                <span class="font-size--14 font-weight-medium mr-1"
                  ><v-icon
                    color="primary"
                    class="font-size--24"
                    :class="leftSideBar ? 'whiteicon' : ''"
                    :icon="mdiCalendar"
                /></span>
                <a
                  href=""
                  class="ml-1 text-decoration-none blueLinkPointer repLinkWrap"
                  :class="leftSideBar ? 'whitetext' : ''"
                  >{{ $t('L_make_an_appointment') }}</a
                >
              </div>
            </div>
          </div>
        </v-row>
      </v-col>
    </v-row>
    <ContactRep
      v-if="contactAgent"
      v-model="contactMe"
      :agents="[contactAgent]"
      @close="contactMe = false"
      @send-message="send($event)"
      close-selector="contact_your_rep_myrep_close"
      modal-class="contact_your_rep_myrep_modal"
      :sender="sender"
    />
    <MessageDialog
      :show-dialog="dialog"
      :has-button-two="true"
      :is-persistent="true"
      type="info"
      :title="$t('L_you_are_being_redirected_to_an_appointment_scheduling_website')"
      :message="$t('L_this_link_will_take_you_to_a_third_party_site_that_has_its_own')"
      :button-two-label="$t('L_go_back')"
      :button-one-label="$t('L_continue')"
      @buttonTwoAction="dialog = false"
      @buttonOneAction="closeAndGoToCalendar"
    />
  </v-container>
</template>

<script lang="ts">
import MessageDialog from '@/components/MessageDialog.vue';
import { phoneNumber } from '@/shared/util/formatters';
import { openInNewWindow } from '@/mixins/openNewWindow';
import { mapActions, mapState } from 'pinia';
import { usePolicyStore } from '../policy/store/policy.store';
import { useCustomerStore } from '@/stores/customer/customer.store';
import { useGlobalStore } from '@/stores/global/global.store';

import repFallbackImage from '../../assets/rep-thumb.svg';
import { mdiCellphone, mdiCalendar, mdiCheckCircle, mdiEmail, mdiPhone, mdiPrinter } from '@mdi/js';
import ContactRep from '@/components/ContactRep/ContactRep.vue';
import { defineComponent, type ComponentOptions } from 'vue';
import { Translations } from '@/i18n/models';
import MyRepAddressComponent from './components/MyRepAddressComponent.vue';
import { Environment } from '@/shared/models/appConfig.model';
import type { IContactRepPayload } from '@/shared/api/models.bff.ts';

const componentOptions: ComponentOptions = {
  name: 'MyRep',
  components: {
    ContactRep,
    MessageDialog,
    MyRepAddressComponent,
  },
  mixins: [openInNewWindow],
  props: {
    repPage: {
      type: Boolean,
      required: false,
      default: true,
    },
    leftSideBar: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data: () => ({
    dialog: false,
    contactMe: false,
    contactAgent: {},
    calendarLink: '',
    repFallbackImage,
    mdiPhone,
    mdiCellphone,
    mdiPrinter,
    mdiEmail,
    mdiCalendar,
    mdiCheckCircle,
    Translations: Translations,
  }),
  computed: {
    ...mapState(usePolicyStore, {
      policiesSortedByDate: 'policiesSortedByDate',
    }),
    ...mapState(useCustomerStore, ['investmentsSortedByDate', 'customerProfile']),
    ...mapState(useGlobalStore, ['agents', 'getAgent']),
    envUrl() {
      const env = window.appConfig.env;
      if (env === Environment.DEV || env === Environment.TEST) {
        return env;
      }
      return 'w';
    },
    sender() {
      return {
        email: this.customerProfile?.email || '',
        phone: this.customerProfile?.mobilePhone || '',
        firstName: this.customerProfile?.firstName,
        lastName: this.customerProfile?.lastName,
      };
    },
    reps() {
      const accounts: Array<{ product?: string; agentId?: string } | null> = [];
      this.policiesSortedByDate.forEach((pol: { contractId?: string; agentId?: string }) => {
        if (pol.contractId && pol.contractId.length > 0) {
          accounts.push({
            product: `${this.$t('L_term_life_policy')} ${pol.contractId}`,
            agentId: pol.agentId,
          });
        }
      });
      this.investmentsSortedByDate.forEach(
        (acct: { accountNumber?: string; productType?: string; agentId?: string }) => {
          if (acct.accountNumber && acct.accountNumber.length > 0) {
            accounts.push({
              product: `${acct.productType} ${acct.accountNumber}`,
              agentId: acct.agentId,
            });
          }
        }
      );
      interface Agent {
        agentId?: string;
        products?: string[];
        displayName?: string;
        name?: string;
      }
      let _reps: Agent[] = [];
      if (accounts.length > 0) {
        accounts.forEach((acct) => {
          const found = _reps.find((a) => a.agentId === acct?.agentId);
          if (!found) {
            // Getters should be side-effect free (https://vuejs.org/guide/essentials/computed#getters-should-be-side-effect-free)
            // ! don't mutate other state, make async requests, or mutate the DOM inside a computed getter!
            const agentFromStore = this.getAgent(acct?.agentId);
            const _agent: Agent | null = agentFromStore
              ? JSON.parse(JSON.stringify(agentFromStore))
              : agentFromStore;
            if (_agent?.agentId) {
              _agent.products = acct?.product ? [acct.product] : [];
              _agent.displayName = _agent.name;
              _reps.push(_agent);
            }
          } else {
            _reps = _reps.map((rep) => {
              if (rep.agentId === acct?.agentId) {
                rep.products?.push(acct?.product ?? '');
              }
              return rep;
            });
          }
        });
      }
      return _reps;
    },
  },
  methods: {
    ...mapActions(useCustomerStore, ['contactRepresentative']),
    ...mapActions(usePolicyStore, {
      getPolicyOverview: 'getPolicyOverview',
    }),
    rvp(id: string) {
      return this.getAgent(id);
    },
    emailRep(agentId: string) {
      const agent = this.reps.find((a: { agentId: string }) => a.agentId === agentId);
      this.contactAgent = agent;
      this.contactMe = true;
    },
    openCalendar(calendarLink: string) {
      this.calendarLink = calendarLink;
      this.dialog = true;
    },
    async closeAndGoToCalendar() {
      this.dialog = false;
      await this.openInNewWindow({ url: this.calendarLink, target: '_blank' });
    },
    send(emailPayload: IContactRepPayload) {
      this.contactRepresentative(emailPayload);
    },
    filterProducts(product: string) {
      return /(Term Life Insurance|Securities|Annuities)/.test(product);
    },
    translatedProductName(product: string) {
      let resDisplayLabel;
      switch (product) {
        case 'Term Life Insurance':
          resDisplayLabel = this.$t('L_term_life_insurance');
          break;
        case 'Securities':
          resDisplayLabel = this.$t('L_securities');
          break;
        case 'Fixed Annuities':
          resDisplayLabel = this.$t('L_fixed_annuities');
          break;
        case 'Indexed Annuities':
          resDisplayLabel = this.$t('L_indexed_annuities');
          break;
        case 'Variable Annuities':
          resDisplayLabel = this.$t('L_variable_annuities');
          break;
        default:
          resDisplayLabel = product;
      }
      return resDisplayLabel;
    },
    phoneFormat(number: string) {
      return phoneNumber(number);
    },
  },
};

export default defineComponent(componentOptions);
</script>

<style scoped lang="scss">
.minHeightMobile {
  min-height: 100px;
}
.minHeightDesktop {
  min-height: 200px;
}
.myrep {
  padding: 8px 0 0 !important;
  min-height: 1400px;
}
.emailButtonCss {
  text-overflow: initial;
  white-space: normal;
  font-size: 13px;
}
.emailBtnWidth {
  width: 115px;
}
.setHeightAuto {
  height: auto !important;
}
.contactElement {
  color: #02579e !important;
  font-size: 16px;
  text-align: center;
}
.navyColorIcon {
  color: #02579e !important;
}
.whitetext {
  color: #ffffff !important;
}
.whiteicon {
  color: #ffffff !important;
}
.backgroundBlueGradient {
  background-image: linear-gradient(to top, #012f60, #013b71);
}
.moveUp {
  margin-top: -3px;
}
.main-body {
  max-width: 1137px;
  margin: auto;
}
.rep-image {
  height: 60px !important;
  width: 80px !important;
}
.parent {
  text-align: center;
}
.listItems {
  display: inline-block;
  text-align: left;
}
text-decoration-none {
  text-decoration: none !important;
}
.blueLinkPointer {
  text-decoration: none;
  color: rgb(12, 109, 202);
  font-weight: 600;
  cursor: pointer;
}
.repLinkWrap {
  flex: 1;
  min-width: 0;
  overflow-wrap: anywhere;
}
.bottomSpacingToAccountForMenu {
  margin-bottom: 160px;
}
.noLeftRightPadding {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
</style>
